import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";

import { GoTrash, GoPencil } from "react-icons/go";
import { useAmbienteMedicao } from "../../../contexts/AmbienteMedicaoContext";
import { useModal } from "../../../contexts/ModalContext";
import useApi from "../../../hooks/useApi";
import { useEffect, useState } from "react";
import ModalEditarGrupo from "./ModalEditarGrupo";
import ConfirmDeleteGrupo from "./ConfirmDeleteGrupo";
import ModalNovoGrupo from "./ModalNovoGrupo";

const Header = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
`
const Titulo = styled.h2`
    margin: 0;
    font-size: 16px;
    color: #333;
`
const BotaoAdicionar = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    &:hover {
        background-color: #1e40af;
    }
    transition: .2s all ease;
    padding: 10px 12px;
    box-sizing: border-box;
    margin-left: auto;
`
const Container = styled.div`
    width: 100%;
    max-height: 450px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    overflow-y: auto;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    thead tr {
        background-color: #f0f0f0;
        height: 40px;
        th {
            padding: 0 15px;
            font-size: 12px;
            font-weight: bold;
            text-align: left;
            color: #333;
        }
    }
    tbody tr {
        height: 40px;
        &:nth-child(even) {
            background-color: #fafafa;
        }
        &:nth-child(odd) {
            background-color: #fff;
        }
        td {
            padding: 0 15px;
            font-size: 12px;
            color: #333;
        }
        &:hover {
            background-color: #e0f7fa;
        }
    }
`
const ColunaNumber = styled.th`
    width: 90px;
`
const ColunaAcoes = styled.td`
    width: 90px;
`
const IconesWrapper = styled.div`
    width: 60px;
    display: flex;
    gap: 12px;
    align-items: center;
`
const Lixeira = styled(GoTrash)`
    height: 18px;
    width: 18px;
    color: #e11d48;
    cursor: pointer;
    &:hover {
        color: #b91c1c;
    }
    transition: .2s all ease;
`
const Editar = styled(GoPencil)`
    height: 18px;
    width: 18px;
    color: #2563eb;
    cursor: pointer;
    &:hover {
        color: #1e40af;
    }
    transition: .2s all ease;
`
const Mensagem = styled.td`
    text-align: center;
    padding: 20px !important;
    color: #666;
    font-style: italic;
`

const ModalGerenciarGrupos = () => {

    const { ambiente } = useAmbienteMedicao();
    const { isModalOpen, openModal, closeModal } = useModal();
    const api = useApi();

    const [loading, setLoading] = useState(false);
    const [grupos, setGrupos] = useState([]);
    const [grupoSelecionado, setGrupoSelecionado] = useState(null);

    const fetchGrupos = async () => {

        if (!ambiente?.id) return;

        try {

            setLoading(true);
            const { data } = await api.get("/Painel/API/ControleMedicao/ListGrupos/index.php?obra=" + ambiente.id);
            setGrupos(Array.isArray(data) ? data : []);

        } catch (e) {

            console.error(e);
            setGrupos([]);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {

        fetchGrupos();

    }, []);

    const handleEditar = (grupo) => {

        setGrupoSelecionado(grupo);
        openModal("modalEditarGrupo");

    }

    const handleExcluir = (grupo) => {

        setGrupoSelecionado(grupo);
        openModal("modalConfirmDeleteGrupo");

    }

    const fecharSubModal = () => {

        setGrupoSelecionado(null);
        closeModal();

    }

    const handleNovoGrupo = () => {

        //Usa um id distinto do botão "CRIAR GRUPO" da sidebar para evitar renderização duplicada do modal.
        openModal("modalNovoGrupoGerenciar");

    }

    return (
        <>
            <Overlay state={true}>
                <Modal header size="lg" close={closeModal}>
                    <Header>
                        <Titulo>GRUPOS | {ambiente?.descricao}</Titulo>
                        <BotaoAdicionar onClick={handleNovoGrupo}>NOVO GRUPO</BotaoAdicionar>
                    </Header>
                    <Container>
                        <Tabela>
                            <thead>
                                <tr>
                                    <ColunaNumber as="th">NÚMERO</ColunaNumber>
                                    <th>DESCRIÇÃO</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading ? (
                                        <tr>
                                            <Mensagem colSpan={3}>CARREGANDO...</Mensagem>
                                        </tr>
                                    ) : grupos.length === 0 ? (
                                        <tr>
                                            <Mensagem colSpan={3}>Nenhum grupo cadastrado para esta obra.</Mensagem>
                                        </tr>
                                    ) : (
                                        grupos.map((g) => (
                                            <tr key={g.id}>
                                                <td>{g.number}</td>
                                                <td>{g.descricao}</td>
                                                <ColunaAcoes>
                                                    <IconesWrapper>
                                                        <Editar title="Editar" onClick={() => handleEditar(g)} />
                                                        <Lixeira title="Excluir" onClick={() => handleExcluir(g)} />
                                                    </IconesWrapper>
                                                </ColunaAcoes>
                                            </tr>
                                        ))
                                    )
                                }
                            </tbody>
                        </Tabela>
                    </Container>
                </Modal>
            </Overlay>
            {
                isModalOpen("modalEditarGrupo") && (
                    <ModalEditarGrupo
                        grupo={grupoSelecionado}
                        fecharModal={fecharSubModal}
                        onUpdated={fetchGrupos}
                    />
                )
            }
            {
                isModalOpen("modalConfirmDeleteGrupo") && (
                    <ConfirmDeleteGrupo
                        grupo={grupoSelecionado}
                        fecharModal={fecharSubModal}
                        onDelete={fetchGrupos}
                    />
                )
            }
            {
                isModalOpen("modalNovoGrupoGerenciar") && (
                    <ModalNovoGrupo
                        onGrupoCreated={fetchGrupos}
                    />
                )
            }
        </>
    );

}

export default ModalGerenciarGrupos;
